<!-- <div class="center">
    <mat-progress-spinner diameter=200 color="accent" mode="indeterminate"></mat-progress-spinner>
</div> -->

<div class="overlay">
    <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</div>
<!-- <mat-progress-spinner mode="indeterminate" diameter=150 color="accent"></mat-progress-spinner> -->